import {
  mapper
} from '@shared/lib';
import {
  mapGameCategory,
  type GameCategory,
} from '@entities/games';

export type GameCategoryBlock = {
  category: Maybe<GameCategory>;
  visibleOnMobile: Maybe<boolean>;
  visibleOnDesktop: Maybe<boolean>;
};

type MapGameCategoryBlock = (data: any) => GameCategoryBlock;
export const mapGameCategoryBlock: MapGameCategoryBlock = mapper([
  {
    name: 'category', from: 'categ.data',
    transform: (data: any) => mapGameCategory(data),
  },
  { name: 'visibleOnMobile' },
  { name: 'visibleOnDesktop' },
]);
